import { render } from "./MdmApprovalTable.vue?vue&type=template&id=2f6bb0fb&scoped=true"
import script from "./MdmApprovalTable.vue?vue&type=script&lang=js"
export * from "./MdmApprovalTable.vue?vue&type=script&lang=js"

import "./MdmApprovalTable.vue?vue&type=style&index=0&id=2f6bb0fb&scoped=true&lang=css"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6bb0fb"]])

export default __exports__